import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

class NewCertificationTypeModal extends React.Component {
  modalRef = null;
  busy = false;
  state = { name: "", valid_for_duration: null, valid_for_units: null };

  componentWillMount() {
    window.addEventListener("openModalToAddCertificateType", () => {
      this.handlerOpenModal();
    });
  }

  render() {
    let { name, valid_for_duration, valid_for_units, busy } = this.state;

    return (
      <div
        className="modal fade"
        ref={el => {
          this.modalRef = el;
        }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h1 className="modal-title">New Certification Type</h1>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-xs-12 col-md-12">
                  <p> * Indicates required field </p>

                  <div className="form-group">
                    <label
                      className="control-label required"
                      htmlFor="certificationTypeName"
                    >
                      Name *
                    </label>

                    <input
                      id="certificationTypeName"
                      placeholder="e.g. CPR / AED"
                      className="form-control"
                      type="text"
                      value={name}
                      onChange={e => {
                        this.setState({ name: e.target.value });
                      }}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label
                      className="control-label"
                      htmlFor="certifcationTypeDuration"
                    >
                      Valid for Duration
                    </label>

                    <input
                      id="certifcationTypeDuration"
                      className="form-control"
                      type="number"
                      value={valid_for_duration}
                      onChange={e => {
                        this.setState({ valid_for_duration: e.target.value });
                      }}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label
                      className="control-label required"
                      htmlFor="certificationTypeUnits"
                    >
                      Valid for Units
                    </label>

                    <select
                      id="certificationTypeUnits"
                      className="form-control"
                      value={valid_for_units}
                      onChange={e => {
                        this.setState({ valid_for_units: e.target.value });
                      }}
                    >
                      <option></option>
                      <option value="days">Days</option>
                      <option value="weeks">Weeks</option>
                      <option value="months">Months</option>
                      <option value="years">Years</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className={`btn btn-pink full-width${
                  name.length === 0 || busy ? " disabled" : ""
                }`}
                onClick={this.handlerSave}
              >
                SAV{busy ? "ING..." : "E"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handlerOpenModal = () => {
    this.setState({ name: "" });
    $(this.modalRef).modal("show");
  };

  handlerSave = () => {
    const data = {
      certification_type: {
        name: this.state.name,
        valid_for_duration: this.state.valid_for_duration,
        valid_for_units: this.state.valid_for_units
      }
    };

    this.setState({ busy: true });
    axios
      .post("/certification_types.json", data)
      .then(this.onSuccess)
      .catch(this.onError);
  };

  onError = error => {
    if (error.response && error.response.data && error.response.data.messages) {
      const messages = error.response.data.messages;
      const keys = Object.keys(messages);
      toastr.error(keys.map(key => `${key} ${messages[key]}`).join(", "));
    } else {
      toastr.error("Certification type not created");
    }
  };

  onSuccess = resp => {
    $(this.modalRef).modal("hide");
    this.props.onAdded(resp.data);

    toastr.success("Certification type created");

    this.setState({ busy: false });
  };
}

NewCertificationTypeModal.propTypes = {
  onAdded: PropTypes.func
};

export default NewCertificationTypeModal;
